import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { tradingApiSlice } from './tradingApiSlice';

type SessionState = {
  userId: number | null;
  username: string | null;
};

const initialState: SessionState = {
  userId: null,
  username: null,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    sessionChanged: (_state, action: PayloadAction<SessionState>) => action.payload,
    sessionCleared: () => initialState,
  },
});

export const { sessionChanged, sessionCleared } = sessionSlice.actions;

export const store = configureStore({
  reducer: {
    session: sessionSlice.reducer,
    [tradingApiSlice.reducerPath]: tradingApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(tradingApiSlice.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
